import { render, staticRenderFns } from "./HistoricalFiles.vue?vue&type=template&id=005e2ca4&scoped=true&"
import script from "./HistoricalFiles.vue?vue&type=script&lang=js&"
export * from "./HistoricalFiles.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalFiles.vue?vue&type=style&index=0&id=005e2ca4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005e2ca4",
  null
  
)

export default component.exports